import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import { green, grey } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ISkillMapHistory } from '../actions/skillMap';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		buttonProgress: {
			color: green[500],
			left: '50%',
			marginLeft: -12,
			marginTop: -12,
			position: 'absolute',
			top: '50%',
		},
		col1: {
			width: '180px',
		},
		col2: {
			width: '140px',
		},
		col3: {
			width: '430px',
		},
		col4: {
			width: '150px',
		},
		paper: {
			display: 'flex',
			flexDirection: 'column',
		},
		root: {
			flexGrow: 1,
			position: 'relative',
		},
		table: {
			backgroundColor: '#FFF',
		},
		tableText: {
			overflow: 'hidden',
			padding: '1px 1px',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			width: 'inherit',
			wordBreak: 'break-all',
		},
		title: {
			flex: 1,
			marginLeft: theme.spacing(2),
		},
	});

/**
 * 更新履歴部品公開プロパティー定義
 */
interface ISkillMapHistoryProp {
	/**
	 * 更新履歴データ
	 */
	history: ISkillMapHistory[];

	/**
	 * ダイアログ開くフラグ
	 */
	open: boolean;

	/**
	 * ダイアログ閉じる時、実行するな方法
	 */
	onClose: (val: any) => void;
}

/**
 * 更新履歴部品内部状態定義
 */
interface IState {
	/**
	 * ダイアログ開くフラグ
	 */
	open: boolean;

	/**
	 * 更新履歴データ
	 */
	datas: ISkillMapHistory[];
}

class SkillMapHistory extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		/**
		 * 状態初期化
		 */
		this.state = {
			datas: [],
			open: false,
		};
	}

	/**
	 * 部品初期化
	 */
	public componentDidMount() {
		this.setState({ datas: [...this.props.history] });
	}

	/**
	 * プロパティー変更
	 * @param newProps
	 */
	public componentWillReceiveProps(newProps: any) {
		this.setState({ open: newProps.open, datas: [...newProps.history] });
	}

	/**
	 * 部品レイアウトレンダリング
	 */
	public render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<Dialog
					open={this.state.open}
					onClose={this.handleClose}
					maxWidth="xl"
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								edge="start"
								color="inherit"
								onClick={this.handleClose}
								aria-label="close"
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" className={classes.title}>
								{i18n.t('SkillMapHistory_0001')}
							</Typography>
						</Toolbar>
					</AppBar>
					<DialogContent>
						<Paper className={classes.paper}>
							<Table
								className={classes.table}
								aria-label="a dense table"
								size="small"
							>
								<TableHead>
									<TableRow
										style={{
											backgroundColor: grey[300],
										}}
									>
										<TableCell
											align="left"
											className={classes.col1}
										>
											{i18n.t('SkillMapHistory_0002')}
										</TableCell>
										<TableCell
											align="left"
											className={classes.col2}
										>
											{i18n.t('SkillMapHistory_0003')}
										</TableCell>
										<TableCell
											align="left"
											className={classes.col3}
										>
											{i18n.t('SkillMapHistory_0004')}
										</TableCell>
										<TableCell
											align="left"
											className={classes.col4}
										>
											{i18n.t('SkillMapHistory_0005')}
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{this.state.datas.map((data, ri) => {
										return (
											<TableRow key={ri}>
												<TableCell
													align="left"
													className={classes.col1}
												>
													{data.updateTime}
												</TableCell>
												<TableCell
													align="left"
													className={classes.col2}
												>
													{data.action === '0'
														? i18n.t(
																'SkillMapHistory_0006'
														  )
														: data.action === '1'
														? i18n.t(
																'SkillMapHistory_0007'
														  )
														: i18n.t(
																'SkillMapHistory_0008'
														  )}
												</TableCell>
												<TableCell
													align="left"
													title={data.comment}
													className={classes.col3}
												>
													<div
														className={
															classes.tableText
														}
													>
														{data.comment}
													</div>
												</TableCell>
												<TableCell
													align="left"
													title={data.updator}
													className={classes.col4}
												>
													<div
														className={
															classes.tableText
														}
													>
														{data.updator}
													</div>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</Paper>
					</DialogContent>
				</Dialog>
			</div>
		);
	}

	/**
	 * ダイアログ閉じる処理
	 */
	protected handleClose = () => {
		// ダイアログを閉じる
		this.setState({ open: false });
		this.props.onClose({});
	};
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISkillMapHistoryProp;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SkillMapHistory);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/SkillMapHistory.tsx